export const scorRu = {
  invoicesTitle: 'Счета',
  invoicesDescription: 'Все ваши счета за подписку и разовые разборы в одном месте.',
  invoiceColumn: 'Счёт',
  invoiceAmountColumn: 'Сумма',
  invoiceDeadlineColumn: 'Срок',
  invoiceActionColumn: 'Действие',
  invoiceListPaid: 'Оплачен',
  invoiceListWaiting: 'В ожидании',
  invoiceListCancelled: 'Отменён',
  invoiceListRefunded: 'Возврат',
  invoiceTable: 'Таблица счетов',
  loadMoreInvoices: 'Показать ещё счета',
  invoiceListRange: 'Показаны {{from}}–{{to}} из {{total}}',
  invoiceListIncomplete: 'Не удалось загрузить часть счетов. Список может быть неполным.',
  noInvoicesYet: 'Счетов пока нет',

  referralSettingsUnavailable: 'Не удалось загрузить настройки реферальной программы',
  reloadReferralSettings: 'Обновить настройки программы',
  currentTermsUnavailable: 'Не удалось загрузить актуальные условия',
  personalInvitations: 'Личный запас приглашений: {{v0}} из {{v1}}',
  invitationsPerReport: 'Квота на один разбор: {{v0}}',
  ownShareReport: 'Мой разбор',
  publicShareReport: 'Открыт всем',
  paymentLinkUnavailable: 'Не удалось получить ссылку на оплату. Попробуйте ещё раз.',
  purchaseHistory: 'История покупок',
  noPurchasesYet: 'Покупок пока нет',
  totalPurchased: 'Всего оплачено',
  purchasePaidAt: 'Оплачено {{v0}}',
  purchaseMonths_one: '{{count}} месяц подписки',
  purchaseMonths_few: '{{count}} месяца подписки',
  purchaseMonths_many: '{{count}} месяцев подписки',
  purchaseMonths_other: '{{count}} месяца подписки',
  purchaseReports_one: '{{count}} оплаченный разбор',
  purchaseReports_few: '{{count}} оплаченных разбора',
  purchaseReports_many: '{{count}} оплаченных разборов',
  purchaseReports_other: '{{count}} оплаченного разбора',
  purchaseExpress_one: '{{count}} доплата за срочность',
  purchaseExpress_few: '{{count}} доплаты за срочность',
  purchaseExpress_many: '{{count}} доплат за срочность',
  purchaseExpress_other: '{{count}} доплаты за срочность',

  payNow: 'Оплатить',
  orderReportNow: 'Заказать разбор',
  pendingPayment: 'Ожидает оплаты',
  orderPriceDetails: 'Стоимость разбора',
  orderPriceBase: 'Стоимость',
  orderPriceDiscount: 'Скидка',
  orderPriceTotal: 'Итого',
  orderPriceIncluded: 'Включено в подписку',
  orderPriceExtra: 'Сверх лимита подписки',
  orderPriceSingle: 'Разовый заказ',

  reportFiles: 'Документы разбора',
  productHistory: 'История продукта',
  openDocument: 'Открыть разбор',
  noReportFile: 'Файл разбора пока не загружен',
  fileUnavailable: 'Файл недоступен',
  fileLoadFailed: 'Не удалось открыть файл. Попробуйте ещё раз.',
  fileLoadStalled: 'Загрузка прервалась: данные не поступают. Проверьте соединение и попробуйте ещё раз.',
  fileLoading: 'Загрузка файла…',
  fileDownloaded: 'Загружено {{size}}…',
  retryFile: 'Повторить',
  previousPage: 'Предыдущая страница',
  nextPage: 'Следующая страница',
  pageOf: 'Страница {{page}} из {{total}}',
  librarySearch: 'Поиск по названию или коду',
  invalidInvitation: 'Ссылка больше не действует',
  invitationPreview: 'Вам открыли доступ к разбору',
  loginForReport: 'Войти и открыть разбор',
  copyInviteCode: 'Скопировать код приглашения',
  copyInviteLink: 'Скопировать ссылку',
  copyFailed: 'Не удалось скопировать. Выделите и скопируйте текст вручную.',
  copiedValue: 'Скопировано',
  reportOrInviteCode: 'Код приглашения или разбора',
  codeExample: 'Например, PQ3KMNH7 или SC-7K3M9A',
  invitationsLeftForReport: 'Доступно приглашений: {{count}}',
  opensWithSubscription: 'Откроется с подпиской',
  getSubscription: 'Оформить подписку',
  noInvitationsAvailable: 'Нет доступных приглашений',
  loadMoreReports: 'Загрузить ещё разборы',
  reportDetails: 'Подробнее',
  days_one: '{{count}} день',
  days_few: '{{count}} дня',
  days_many: '{{count}} дней',
  days_other: '{{count}} дней',
  includedReports_one: '{{count}} разбор включён',
  includedReports_few: '{{count}} разбора включено',
  includedReports_many: '{{count}} разборов включено',
  includedReports_other: '{{count}} разборов включено',
  outcomeReports_one: '{{count}} разбор с известным исходом',
  outcomeReports_few: '{{count}} разбора с известным исходом',
  outcomeReports_many: '{{count}} разборов с известным исходом',
  outcomeReports_other: '{{count}} разборов с известным исходом',
  invitations_one: '{{count}} приглашение',
  invitations_few: '{{count}} приглашения',
  invitations_many: '{{count}} приглашений',
  invitations_other: '{{count}} приглашений',
  workingDays_one: '{{count}} рабочий день',
  workingDays_few: '{{count}} рабочих дня',
  workingDays_many: '{{count}} рабочих дней',
  workingDays_other: '{{count}} рабочих дней',
  outcomeLabel_one: 'разбор с известным исходом',
  outcomeLabel_few: 'разбора с известным исходом',
  outcomeLabel_many: 'разборов с известным исходом',
  outcomeLabel_other: 'разборов с известным исходом',
  onRequest: 'По запросу',
  commentMustNotExceed2000Characters: 'Комментарий — не более 2000 символов',
  scorDocument: 'Документ SCOR',
  openInANewTab: 'Открыть в новой вкладке',
  unableToLoadDataTryRefreshingThe: 'Не удалось загрузить данные. Попробуйте обновить страницу.',
  subscribe: 'Подключить подписку',
  nothingHereYet: 'Пока здесь ничего нет',
  untitled: 'Без названия',
  scorReport: 'SCOR-отчёт',
  score: 'Оценка {{v0}}: {{v1}}',
  highRisk: 'высокий риск',
  needsAttention: 'требует внимания',
  positiveAssessment: 'положительная оценка',
  noScoreAvailable: 'Оценка отсутствует',
  open: 'Открыть',
  overview: 'Обзор',
  requestAReport: 'Заказать разбор',
  myReports: 'Мои Scor-разборы',
  myScorReports: 'Мои Scor-разборы',
  reportLibrary: 'База разборов',
  sharedWithMe: 'Со мной поделились',
  myInvitations: 'Мои приглашения',
  of: '{{v0}} из {{v1}}',
  inviteAFriend: 'Пригласить друга',
  pricesAndPurchases: 'Цены и покупки',
  subscriptionAndPricing: 'Подписка и цены',
  questionsAndAnswers: 'Вопросы и ответы',
  documents: 'Документы',
  scorSubscription: 'Подписка SCOR',
  activeUntil: 'Активна до {{v0}}',
  requestSubmitted: 'Заявка отправлена',
  fullAccessToScor: 'Полный доступ к SCOR',
  aManagerWillContactYou: 'Менеджер свяжется с вами.',
  perMonth: 'в месяц',
  reportsThisPeriod: 'Разбор месяца:',
  of33: 'из',
  remaining: 'Осталось',
  scorNavigation: 'Навигация SCOR',
  recordedOutcomes: 'Известные исходы',
  weAlsoShowDiscrepancies: '. Расхождения показываем тоже.',
  request: 'Заявка',
  openReport: 'Открыть отчёт',
  chat: 'Чат',
  informationSentToTheAnalyst: 'Данные отправлены аналитику',
  additionalInformation: 'Дополнение к заявке',
  commentForTheAnalyst: 'Комментарий аналитику',
  remove: 'Удалить {{v0}}',
  unableToLoadUploadSettings: 'Не удалось загрузить настройки файлов.',
  reload: 'Повторить загрузку',
  addFiles: 'Добавить файлы',
  send: 'Отправить',
  filesForTheAnalyst: 'Файлы для аналитика',
  scorInvestmentAnalysis: 'SCOR · Инвестиционный разбор',
  investmentAnalysis: 'Аналитический разбор',
  decisionsStartWithDocumentsNotPromises: 'Решение начинается с документов, а не с обещаний.',
  scorBringsTheTermsOfAnOffer: 'SCOR собирает условия предложения в единый разбор: экономика продавца, ваши сценарии выплаты, ликвидность, юридические ограничения и вопросы, которые нельзя оставить без ответа.',
  startANewReport: 'Открыть новый разбор',
  scorAnalyticalReport: 'Аналитическое досье SCOR',
  reportStatus: 'Готовность разбора',
  readyToStart: 'Можно начинать',
  documentsRequired: 'Требуются документы',
  reviewScopeDefined: 'Контур сформирован',
  reviewScope: 'Контур проверки',
  '5Factors': '5 факторов',
  economicsAndRisks: 'Экономика и риски',
  scorAnalysis: 'SCOR / Разбор',
  independentAssessment: 'Независимая оценка',
  areasOfReview: 'Контуры проверки',
  termsAndAnnexes: 'условия и приложения',
  dealEconomics: 'Экономика сделки',
  feesAndScenarios: 'комиссии и сценарии',
  liquidity: 'Ликвидность',
  exitOptionsAndRestrictions: 'выход и ограничения',
  riskAssessment: 'Контроль риска',
  independentScor: 'независимый SCOR',
  termsReview: 'Проверка условий',
  feesAndDealStructure: 'комиссии и структура сделки',
  exitScenarios: 'Сценарии выхода',
  liquidityAndRestrictions: 'ликвидность и ограничения',
  independentScore: 'Независимый балл',
  '110Methodology': 'методология 1–10',
  yourReports: 'Ваши разборы',
  ongoingAndCompletedReviews: 'Рабочие и завершённые проверки',
  archive: 'Архив',
  yourOngoingAndCompletedReportsWillAppear: 'Здесь появятся ваши рабочие и завершённые разборы.',
  scorReport83: 'SCOR-разбор',
  inProgress: 'В работе',
  underReview: 'На рассмотрении',
  ready: 'Готов',
  informationNeeded: 'Нужны данные',
  completedReport: 'Завершённый отчёт',
  analystSNote: 'Записка аналитика',
  theMainRiskOftenLiesInEarly: 'Главный риск часто скрыт не в доходности, а в условиях досрочного выхода.',
  weComparePromisesWithDocumentsAndReview: 'Сопоставляем обещания с документами, проверяем ликвидность и полную стоимость продажи продукта.',
  exploreSimilarCases: 'Посмотреть похожие кейсы →',
  whileYourReportIsBeingPrepared: 'Пока готовится ваш разбор',
  similarCasesFromTheReportLibrary: 'Материалы из общей базы с похожими кейсами',
  hours: '{{v0}} часов',
  timingConfirmedWithYourRequest: 'Срок по заявке',
  includedInYourSubscription: 'Входит в подписку',
  amountDue: 'К оплате {{v0}}',
  priceOnRequest: 'Цена по запросу',
  selectAReportType: 'Выберите тип разбора',
  completeTheRequiredFields: 'Заполните обязательные поля',
  checkTheFormFields: 'Проверьте заполнение полей',
  requestCreated: 'Заявка создана',
  scorNewAnalyticalReport: 'SCOR · Новый аналитический разбор',
  reviewBeforeInvesting: 'Проверка до сделки',
  shareTheDocumentsWeWillTurnThem: 'Передайте документы. Мы соберём из них решение.',
  anAnalystWillReviewTheOfferS: 'Аналитик проверит экономику предложения, комиссии, ликвидность, юридические ограничения и зафиксирует независимый SCOR.',
  confidential: 'Конфиденциально',
  reportInTheApp: 'Разбор в приложении',
  investmentDocumentReview: 'Проверка инвестиционных документов',
  reviewTerms: 'Условия разбора',
  offerDetails: 'Параметры предложения',
  yourRequestIsSubmittedOnlyAfterYou: '. Заявка создаётся только после вашего подтверждения.',
  unableToLoadReviewSettings: 'Не удалось загрузить параметры разбора',
  pleaseTryAgainLater: 'Попробуйте повторить запрос немного позже.',
  retry: 'Повторить',
  noCategoriesOrReportTypesAreCurrently: 'Сейчас нет доступных категорий или типов разбора.',
  whatAreWeReviewing: 'Что проверяем *',
  reportCategory: 'Категория разбора',
  reportType: 'Тип разбора *',
  reportType121: 'Тип разбора',
  hrs: '{{v0}} ч.',
  standardTurnaround: 'Стандартный срок',
  onRequest124: 'по запросу',
  productNameOrIssuer: 'Название или эмитент *',
  forExampleAgrotechPreIpo: 'Например, AgroTech Pre-IPO',
  investmentAmountRub: 'Сумма сделки, ₽',
  optional: 'необязательно',
  optionsCouldNotBeLoaded: 'Варианты выбора не загрузились',
  theServiceDidNotProvideOptionsFor: 'Сервис не передал допустимые значения для поля «',
  dragDocumentsHereForReview: 'Перетащите документы для проверки',
  acceptedFormats: 'Допустимые форматы:',
  chooseFiles: 'Выбрать файлы',
  comment: 'Комментарий',
  whatConcernsYouOrNeedsParticularAttention: 'Что именно смущает или что важно проверить',
  youHaveAlreadyAcceptedTheCurrentDocument: 'Действующая оферта уже принята',
  iAcceptTheOfferAndPersonalData: 'Согласен с офертой и обработкой персональных данных. Документы используются только для проведения разбора.',
  theOfferContainsTheTermsForAdding: 'Условия использования разбора в базе — в оферте',
  submitRequest: 'Отправить заявку',
  preparationTime: 'Срок подготовки:',
  theAnalystWillContactYouIfMore: '. Аналитик напишет, если информации будет недостаточно.',
  ongoingRequestsAndPublishedScorReports: 'Заявки в работе и опубликованные SCOR-разборы.',
  newAssessment: 'Новая оценка',
  requestsInProgress: 'Заявки в работе',
  request146: 'Заявка №{{v0}}',
  completedReports: 'Готовые разборы',
  noCompletedReportsYet: 'Готовых разборов пока нет',
  yes: 'Да',
  no: 'Нет',
  independentAssessmentResults: 'Итог независимой оценки',
  investmentProductReport: 'Досье инвестиционного продукта',
  advertisedReturn: 'Заявленная доходность: {{v0}}',
  conclusionsAreBasedOnDocumentsAndIndependent: 'Выводы сформированы на основе документов и независимой аналитики.',
  share: 'Поделиться',
  keyFindings: 'Ключевые выводы',
  detailedFindingsWillAppearAfterTheReport: 'Развёрнутые выводы появятся после публикации отчёта',
  outcome: 'Результат',
  stillBeingMonitored: 'Пока отслеживается',
  checked: 'Проверено:',
  scoresByCriterion: 'Оценки по параметрам',
  questionsForTheSeller: 'Вопросы продавцу',
  back: 'Назад',
  anonymizedAnalysis: 'Обезличенная аналитика',
  investmentProductsWithIndependentScorAssessmentsAnd: 'Каталог инвестиционных продуктов с независимой SCOR-оценкой и фактическими исходами.',
  all: 'Все ·',
  withOutcomes: 'С исходом ·',
  youHaveAccessToPartOfThe: 'Доступна часть базы разборов.',
  inTheLibrary: 'В базе',
  outcomeRecorded: 'Исход известен',
  inThisSelection: 'В выборке',
  medianScore: 'Медиана выборки',
  reportCategories: 'Категории разборов',
  all174: 'Все',
  category: 'Категория',
  noPublishedReportsInThisSelectionYet: 'В этой выборке пока нет опубликованных разборов',
  investmentProduct: 'Инвестиционный продукт',
  beingMonitored: 'На наблюдении',
  actualOutcome: 'Фактический результат: {{v0}}',
  anAnonymizedAnalysisOfTheProductS: 'Обезличенный аналитический разбор условий, ограничений и ключевых факторов продукта.',
  channel: 'Канал',
  checked182: 'Проверено',
  actualOutcomeRecorded: 'фактический исход учтён',
  monitoringContinues: 'наблюдение продолжается',
  openReport185: 'Открыть досье',
  availableToMe: 'Доступные мне',
  reportsSharedWithYouByOtherUsers: 'Разборы, которыми с вами поделились другие участники.',
  sharedScorReport: 'Общий SCOR-отчёт',
  protectedAccessByInvitation: 'Защищённый доступ по приглашению',
  publicReportCode: 'Публичный SCOR-код',
  findAReportByCode: 'Найти разбор по коду',
  checkAReportSAvailabilityAndYour: 'Проверьте существование разбора и доступ к нему по публичному SCOR-коду.',
  forExampleSc7k3m9a: 'Например, SC-7K3M9A',
  find: 'Найти',
  scorReportSearch: 'Поиск SCOR-досье',
  invitations: 'Приглашения',
  ofInvitationsUsed: 'Использовано {{v0}} из {{v1}} доступов.',
  newInvitation: 'Новый доступ',
  report: 'Отчёт №{{v0}}',
  accessViaLink: 'Доступ по ссылке',
  views: 'Просмотров',
  until: 'До',
  active: 'Активно',
  closed: 'Закрыто',
  revoke: 'Отозвать',
  invitationRegister: 'Реестр приглашений',
  invalidRecipientPhone: 'Введите корректный номер телефона с кодом страны',
  enterTheRecipientSPhoneNumber: 'Укажите телефон получателя',
  linkCopied: 'Ссылка скопирована',
  shareAccessToAReport: 'Открыть доступ к разбору',
  createAProtectedLinkOrTieAn: 'Создайте защищённую ссылку или привяжите приглашение к номеру телефона.',
  report210: 'Разбор *',
  selectAReport: 'Выберите разбор',
  manageInvitations: 'Управлять приглашениями',
  accessMode: 'Режим доступа',
  byLink: 'По ссылке',
  byPhone: 'По телефону',
  recipientSPhoneNumber: 'Телефон получателя',
  message: 'Сообщение',
  createInvitation: 'Создать доступ',
  copy: 'Скопировать',
  codeApplied: 'Код применён',
  invitationCodeCopied: 'Код приглашения скопирован',
  referralProgram: 'Реферальная программа',
  theProgramIsCurrentlyUnavailable: 'Программа сейчас недоступна.',
  newInvitationsAreTemporarilyUnavailable: 'Новые приглашения временно не принимаются.',
  referralProgramYourNetwork: 'Реферальная программа · Частный круг',
  yourSharesproNetwork: 'Частный круг SharesPro',
  anInvitationGivesPersonalAccessNotA: 'Приглашение как персональный доступ, а не промокод.',
  shareSharesproWithSomeoneYouKnowThe: 'Передайте SharesPro человеку из своего круга. Код фиксирует источник приглашения, а кабинет показывает только необходимые статусы.',
  loading: 'Загрузка',
  shareInvitation: 'Передать приглашение',
  yourNetwork: 'Частный круг',
  confirmed: 'подтверждено',
  accessLevel: 'Уровень доступа',
  personal: 'Персональный',
  withAnIndividualCode: 'По индивидуальному коду',
  yourNetworkSharespro: 'Частный круг · SharesPro',
  becameClients: 'Стали клиентами',
  programStatus: 'Статус программы',
  active239: 'Активна',
  unavailable: 'Недоступна',
  programOverview: 'Реестр программы',
  availableStatisticsForYourNetwork: 'Доступные агрегаты вашего частного круга',
  codeShared: 'Передали код',
  totalRecordedInvitations: 'Всего зафиксированных приглашений',
  confirmedProgramParticipants: 'Подтверждённые участники программы',
  programTerms: 'Условия программы',
  yourPersonalManagerCanConfirmTheCurrent: 'Актуальные условия подтверждает персональный менеджер',
  howAccessWorks: 'Порядок доступа',
  aCodeCanOnlyBeAppliedOnce: 'Код можно применить один раз.',
  programTermsMayChangeYourPersonalManager: 'Условия программы могут меняться и подтверждаются персональным менеджером.',
  shareTheCode: 'Передайте код',
  inAnyConvenientWay: 'Любым удобным способом.',
  yourFriendEntersIt: 'Друг вводит его',
  duringRegistrationOrInTheirProfile: 'При регистрации или в профиле.',
  invitationCode: 'Полученный код',
  enterYourInvitationCode: 'Введите полученный код',
  apply: 'Применить',
  aReferralCodeIsAlreadyLinkedTo: 'Партнёрский код уже привязан к аккаунту',
  scorInvoice: 'Счёт SCOR',
  invoice: 'Счёт №{{v0}}',
  validUntil: 'Действует до {{v0}}',
  noPaymentDeadlineSpecified: 'Без указанного срока оплаты',
  onlinePayment: 'Онлайн-оплата',
  bankTransfer: 'Банковский перевод',
  overdue: 'Просрочен',
  awaitingPayment: 'Ожидает оплаты',
  openInvoice: 'Открыть счёт',
  payUsingYourBankSApp: 'Оплата через приложение банка',
  scanTheQrCode: 'Отсканируйте QR-код',
  yourBankWillFillInTheAmount: 'Банк заполнит сумму, получателя и назначение платежа автоматически.',
  unableToGenerateAQrCodeUse: 'Не удалось построить QR. Используйте реквизиты ниже.',
  invoicePaymentQrCode: 'QR-код для оплаты счёта',
  saveQrCode: 'Сохранить QR',
  recipient: 'Получатель',
  taxIdInn: 'ИНН',
  taxRegistrationCodeKpp: 'КПП',
  accountNumber: 'Расчётный счёт',
  bank: 'Банк',
  bankIdentificationCodeBik: 'БИК',
  correspondentAccount: 'Корреспондентский счёт',
  copied: 'Скопировано: {{v0}}',
  unableToCopyTheValue: 'Не удалось скопировать значение',
  enterYourFirstAndLastNameAt: 'Укажите фамилию и имя — минимум два слова.',
  enterAValidEmailAddressForThe: 'Укажите корректный email для отправки чека.',
  payerDetailsSaved: 'Данные плательщика сохранены',
  thePaymentLinkWillAppearAfterThe: 'Ссылка на оплату появится после обновления счёта.',
  youCanNowPayUsingTheQr: 'Теперь можно оплатить счёт по QR или реквизитам.',
  refreshTheInvoiceToCheckThePayment: 'Обновите счёт, чтобы уточнить способ оплаты.',
  invoiceNotFound: 'Счёт не найден',
  theInvoiceWasNotFoundOrIs: 'Счёт не найден или недоступен.',
  checkTheLinkOrReturnToYour: 'Проверьте ссылку или вернитесь к списку счетов.',
  subscriptionAndInvoices: 'К подписке и счетам',
  loadingCurrentPaymentDetails: 'Загружаем актуальные данные оплаты.',
  unableToLoadPaymentDetails: 'Не удалось загрузить данные оплаты.',
  scorPayment: 'Оплата SCOR',
  checkTheAmountAndChooseAnAvailable: 'Проверьте сумму и выберите доступный способ оплаты.',
  backToInvoices: 'Назад к счетам',
  unableToRefreshTheStatusTheLast: 'Не удалось обновить статус. Последние полученные данные сохранены.',
  amountDue299: 'К оплате',
  invoiceStatus: 'Статус счёта',
  invoiceType: 'Тип счёта',
  issued: 'Выставлен',
  payBy: 'Оплатить до',
  order: 'Заказ',
  notLinked: 'Не привязан',
  paymentDeadlinePassed: 'Срок оплаты прошёл',
  youCanStillPayThisInvoiceIts: 'Счёт остаётся открытым. Его по-прежнему можно оплатить.',
  paymentReceived: 'Оплата получена',
  theInvoiceStatusHasBeenUpdatedNo: 'Статус счёта обновлён. Дополнительных действий не требуется.',
  invoiceClosed: 'Счёт закрыт',
  thisInvoiceCanNoLongerBePaid: 'Оплата по этому счёту больше недоступна.',
  receiptDetails: 'Данные для чека',
  enterPayerDetails: 'Укажите плательщика',
  thePayerSNameWillAppearIn: 'ФИО попадёт в назначение платежа, а чек придёт на email.',
  firstAndLastName: 'Фамилия и имя *',
  receiptEmail: 'Email для чека *',
  saveAndProceedToPayment: 'Сохранить и перейти к оплате',
  saveAndShowBankDetails: 'Сохранить и показать реквизиты',
  saveDetails: 'Сохранить данные',
  thePaymentMethodIsNotYetAvailable: 'Способ оплаты пока недоступен.',
  refreshInvoice: 'Обновить счёт',
  payOnTheSecurePage: 'Оплатите на защищённой странице',
  theLinkWillOpenOnThisDevice: 'Ссылка откроется на этом устройстве и может сразу запустить приложение банка.',
  proceedToPayment: 'Перейти к оплате',
  theLinkIsNotYetAvailable: 'Ссылка пока недоступна.',
  paymentDetails: 'Реквизиты платежа',
  copy327: 'Скопировать: {{v0}}',
  bankDetailsHaveNotBeenPublishedYet: 'Реквизиты пока не опубликованы. Обновите счёт позже.',
  paymentReference: 'Назначение платежа',
  reference: 'Назначение',
  enterYourPhoneNumber: 'Укажите телефон',
  acceptanceOfTheOfferIsRequired: 'Необходимо согласие с офертой',
  selectAnAvailablePlanAndBillingPeriod: 'Выберите доступный тариф и период',
  aManagerWillContactYouShortly: 'Менеджер свяжется с вами в ближайшее время.',
  fullAccessToReportsRecordedOutcomesAnd: 'Полный доступ к разборам, базе исходов и защищённому обмену.',
  subscriptionActive: 'Подписка активна',
  discountOnAdditionalReports: 'Скидка на дополнительные разборы',
  upTo: 'До',
  protectedInvitations: 'защищённых доступов',
  yourAccess: 'Ваш доступ',
  paidUntil: 'Оплачено до',
  reportsUsed: 'Использовано разборов:',
  reportsRemaining: 'Осталось разборов:',
  period: 'Период:',
  requestAmount: 'Сумма заявки:',
  unableToLoadYourRequestStatus: 'Не удалось загрузить состояние заявки.',
  checkYourContactPhoneNumberNameAnd: 'Проверьте телефон для связи. Имя и email можно оставить пустыми.',
  plan: 'Тариф',
  selectAPlan: 'Выберите тариф',
  billingPeriod: 'Период оплаты',
  selectAPeriod: 'Выберите период',
  perPeriod: 'за период',
  selectAnAvailablePlanAndBillingPeriod353: 'Выберите доступный тариф и период.',
  reloadPlans: 'Повторить загрузку тарифов',
  select: 'Выбрать',
  yourName: 'Как к вам обращаться',
  phone: 'Телефон *',
  iAcceptTheOffer: 'Согласен с офертой',
  requestSubscription: 'Оставить заявку',
  plans: 'Тарифы',
  payment: 'Оплата',
  invoicesAwaitingPayment: 'Счета к оплате',
  support: 'Поддержка',
  aboutScorMethodologySubscriptionsAndPrivacy: 'О методике, подписке и конфиденциальности SCOR.',
  stillHaveAQuestion: 'Не нашли ответ?',
  messageTheSharesproSupportChat: 'Напишите в общий чат поддержки SharesPro.',
  openChat: 'Открыть чат',
  scorRulesAndSecurity: 'SCOR · Правила и безопасность',
  legalDocuments: 'Юридический контур',
  scorDocuments: 'Документы SCOR',
  serviceTermsConsentsAndCurrentDocumentVersions: 'Правила сервиса, согласия и актуальные редакции документов собраны в одном защищённом разделе.',
  currentVersions: 'Актуальные версии',
  consentTracking: 'Контроль согласий',
  protectedAccess: 'Защищённый доступ',
  protectedScorDocumentStorage: 'Защищённое хранилище документов SCOR',
  documents376: 'Документов',
  consentRequired: 'Требуют согласия',
  status: 'Статус',
  upToDate: 'Всё актуально',
  actionNeeded: 'Нужно действие',
  documentsHaveNotBeenPublishedYet: 'Документы пока не опубликованы.',
  version: 'Версия',
  effectiveFrom: '· действует с',
  consentRequired384: 'Требует согласия',
  open385: 'Открыть →',
  selectACategory: 'Выберите категорию',
  enterAProductNameOrIssuer: 'Укажите название или эмитента',
  noMoreThan255Characters: 'Не более 255 символов',
  noMoreThan2000Characters: 'Не более 2000 символов',
  youMustAcceptTheDocuments: 'Необходимо согласие с документами',
  addAtLeastOneDocument: 'Добавьте хотя бы один документ',
  enterAnAmountOf0OrMore: 'Укажите сумму не меньше 0',
  confirmationRequired: 'Необходимо подтверждение',
  completeThisRequiredField: 'Заполните обязательное поле',
  selectAnAvailableOption: 'Выберите доступный вариант',
  enterANumber: 'Укажите число',
  businessDays: '{{v0}} рабочих дней',
  businessDay: '{{v0}} рабочий день',
  businessDays399: '{{v0}} рабочих дня',
  unableToLoadUploadSettingsPleaseReload: 'Не удалось загрузить настройки файлов. Повторите загрузку.',
  youCanAttachUpToFiles: 'Можно приложить не более {{v0}} файлов',
  theFileExceeds: '{{v0}}: размер превышает {{v1}}',
  mb: '{{v0}} МБ',
  bytes: '{{v0}} байт',
  unsupportedFileFormat: '{{v0}}: недопустимый формат файла',
} as const;

export const scorEn: Record<keyof typeof scorRu, string> = {
  invoicesTitle: 'Invoices',
  invoicesDescription: 'All your subscription and individual report invoices in one place.',
  invoiceColumn: 'Invoice',
  invoiceAmountColumn: 'Amount',
  invoiceDeadlineColumn: 'Due date',
  invoiceActionColumn: 'Action',
  invoiceListPaid: 'Paid',
  invoiceListWaiting: 'Awaiting payment',
  invoiceListCancelled: 'Cancelled',
  invoiceListRefunded: 'Refunded',
  invoiceTable: 'Invoice table',
  loadMoreInvoices: 'Show more invoices',
  invoiceListRange: 'Showing {{from}}–{{to}} of {{total}}',
  invoiceListIncomplete: 'Some invoices could not be loaded. The list may be incomplete.',
  noInvoicesYet: 'No invoices yet',

  referralSettingsUnavailable: 'Unable to load referral program settings',
  reloadReferralSettings: 'Reload program settings',
  currentTermsUnavailable: 'Unable to load the current terms',
  personalInvitations: 'Personal invitations remaining: {{v0}} of {{v1}}',
  invitationsPerReport: 'Invitations per report: {{v0}}',
  ownShareReport: 'My report',
  publicShareReport: 'Public report',
  paymentLinkUnavailable: 'Unable to obtain a payment link. Please try again.',
  purchaseHistory: 'Purchase history',
  noPurchasesYet: 'No purchases yet',
  totalPurchased: 'Total paid',
  purchasePaidAt: 'Paid on {{v0}}',
  purchaseMonths_one: '{{count}} month of subscription',
  purchaseMonths_few: '{{count}} months of subscription',
  purchaseMonths_many: '{{count}} months of subscription',
  purchaseMonths_other: '{{count}} months of subscription',
  purchaseReports_one: '{{count}} paid report',
  purchaseReports_few: '{{count}} paid reports',
  purchaseReports_many: '{{count}} paid reports',
  purchaseReports_other: '{{count}} paid reports',
  purchaseExpress_one: '{{count}} express surcharge',
  purchaseExpress_few: '{{count}} express surcharges',
  purchaseExpress_many: '{{count}} express surcharges',
  purchaseExpress_other: '{{count}} express surcharges',

  payNow: 'Pay',
  orderReportNow: 'Order a report',
  pendingPayment: 'Awaiting payment',
  orderPriceDetails: 'Report price',
  orderPriceBase: 'Price',
  orderPriceDiscount: 'Discount',
  orderPriceTotal: 'Total',
  orderPriceIncluded: 'Included in the subscription',
  orderPriceExtra: 'Above the subscription limit',
  orderPriceSingle: 'One-time order',

  reportFiles: 'Report documents',
  productHistory: 'Product history',
  openDocument: 'Open report',
  noReportFile: 'The report file has not been uploaded yet',
  fileUnavailable: 'File unavailable',
  fileLoadFailed: 'Unable to open the file. Please try again.',
  fileLoadStalled: 'The download stalled. Check your connection and try again.',
  fileLoading: 'Loading file…',
  fileDownloaded: 'Downloaded {{size}}…',
  retryFile: 'Retry',
  previousPage: 'Previous page',
  nextPage: 'Next page',
  pageOf: 'Page {{page}} of {{total}}',
  librarySearch: 'Search by name or code',
  invalidInvitation: 'This link is no longer valid',
  invitationPreview: 'You have been invited to read a report',
  loginForReport: 'Sign in to read the report',
  copyInviteCode: 'Copy invitation code',
  copyInviteLink: 'Copy invitation link',
  copyFailed: 'Unable to copy. Select and copy the text manually.',
  copiedValue: 'Copied',
  reportOrInviteCode: 'Invitation or report code',
  codeExample: 'For example, PQ3KMNH7 or SC-7K3M9A',
  invitationsLeftForReport: 'Invitations available: {{count}}',
  opensWithSubscription: 'Available with a subscription',
  getSubscription: 'Get a subscription',
  noInvitationsAvailable: 'No invitations available',
  loadMoreReports: 'Load more reports',
  reportDetails: 'View details',
  days_one: '{{count}} day',
  days_few: '{{count}} days',
  days_many: '{{count}} days',
  days_other: '{{count}} days',
  includedReports_one: '{{count}} report included',
  includedReports_few: '{{count}} reports included',
  includedReports_many: '{{count}} reports included',
  includedReports_other: '{{count}} reports included',
  outcomeReports_one: '{{count}} report with a recorded outcome',
  outcomeReports_few: '{{count}} reports with recorded outcomes',
  outcomeReports_many: '{{count}} reports with recorded outcomes',
  outcomeReports_other: '{{count}} reports with recorded outcomes',
  invitations_one: '{{count}} invitation',
  invitations_few: '{{count}} invitations',
  invitations_many: '{{count}} invitations',
  invitations_other: '{{count}} invitations',
  workingDays_one: '{{count}} business day',
  workingDays_few: '{{count}} business days',
  workingDays_many: '{{count}} business days',
  workingDays_other: '{{count}} business days',
  outcomeLabel_one: 'report with a recorded outcome',
  outcomeLabel_few: 'reports with recorded outcomes',
  outcomeLabel_many: 'reports with recorded outcomes',
  outcomeLabel_other: 'reports with recorded outcomes',
  onRequest: 'On request',
  commentMustNotExceed2000Characters: 'Comment must not exceed 2,000 characters',
  scorDocument: 'SCOR document',
  openInANewTab: 'Open in a new tab',
  unableToLoadDataTryRefreshingThe: 'Unable to load data. Try refreshing the page.',
  subscribe: 'Subscribe',
  nothingHereYet: 'Nothing here yet',
  untitled: 'Untitled',
  scorReport: 'SCOR report',
  score: 'Score {{v0}}: {{v1}}',
  highRisk: 'high risk',
  needsAttention: 'needs attention',
  positiveAssessment: 'positive assessment',
  noScoreAvailable: 'No score available',
  open: 'Open',
  overview: 'Overview',
  requestAReport: 'Request a report',
  myReports: 'My reports',
  myScorReports: 'My SCOR reports',
  reportLibrary: 'Report library',
  sharedWithMe: 'Shared with me',
  myInvitations: 'My invitations',
  of: '{{v0}} of {{v1}}',
  inviteAFriend: 'Invite a friend',
  pricesAndPurchases: 'Prices and purchases',
  subscriptionAndPricing: 'Subscription and pricing',
  questionsAndAnswers: 'Questions and answers',
  documents: 'Documents',
  scorSubscription: 'SCOR subscription',
  activeUntil: 'Active until {{v0}}',
  requestSubmitted: 'Request submitted',
  fullAccessToScor: 'Full access to SCOR',
  aManagerWillContactYou: 'A manager will contact you.',
  perMonth: 'per month',
  reportsThisPeriod: 'Reports this period:',
  of33: 'of',
  remaining: 'Remaining',
  scorNavigation: 'SCOR navigation',
  recordedOutcomes: 'Recorded outcomes',
  weAlsoShowDiscrepancies: '. We also show discrepancies.',
  request: 'Request',
  openReport: 'Open report',
  chat: 'Chat',
  informationSentToTheAnalyst: 'Information sent to the analyst',
  additionalInformation: 'Additional information',
  commentForTheAnalyst: 'Comment for the analyst',
  remove: 'Remove {{v0}}',
  unableToLoadUploadSettings: 'Unable to load upload settings.',
  reload: 'Reload',
  addFiles: 'Add files',
  send: 'Send',
  filesForTheAnalyst: 'Files for the analyst',
  scorInvestmentAnalysis: 'SCOR · Investment analysis',
  investmentAnalysis: 'Investment analysis',
  decisionsStartWithDocumentsNotPromises: 'Decisions start with documents, not promises.',
  scorBringsTheTermsOfAnOffer: 'SCOR brings the terms of an offer into one report: the seller’s economics, payment scenarios, liquidity, legal restrictions, and questions that need answers.',
  startANewReport: 'Start a new report',
  scorAnalyticalReport: 'SCOR analytical report',
  reportStatus: 'Report status',
  readyToStart: 'Ready to start',
  documentsRequired: 'Documents required',
  reviewScopeDefined: 'Review scope defined',
  reviewScope: 'Review scope',
  '5Factors': '5 factors',
  economicsAndRisks: 'Economics and risks',
  scorAnalysis: 'SCOR / Analysis',
  independentAssessment: 'Independent assessment',
  areasOfReview: 'Areas of review',
  termsAndAnnexes: 'terms and annexes',
  dealEconomics: 'Deal economics',
  feesAndScenarios: 'fees and scenarios',
  liquidity: 'Liquidity',
  exitOptionsAndRestrictions: 'exit options and restrictions',
  riskAssessment: 'Risk assessment',
  independentScor: 'independent SCOR',
  termsReview: 'Terms review',
  feesAndDealStructure: 'fees and deal structure',
  exitScenarios: 'Exit scenarios',
  liquidityAndRestrictions: 'liquidity and restrictions',
  independentScore: 'Independent score',
  '110Methodology': '1–10 methodology',
  yourReports: 'Your reports',
  ongoingAndCompletedReviews: 'Ongoing and completed reviews',
  archive: 'Archive',
  yourOngoingAndCompletedReportsWillAppear: 'Your ongoing and completed reports will appear here.',
  scorReport83: 'SCOR report',
  inProgress: 'In progress',
  underReview: 'Under review',
  ready: 'Ready',
  informationNeeded: 'Information needed',
  completedReport: 'Completed report',
  analystSNote: 'Analyst’s note',
  theMainRiskOftenLiesInEarly: 'The main risk often lies in early exit terms, not the promised return.',
  weComparePromisesWithDocumentsAndReview: 'We compare promises with documents and review liquidity and the full cost of selling the product.',
  exploreSimilarCases: 'Explore similar cases →',
  whileYourReportIsBeingPrepared: 'While your report is being prepared',
  similarCasesFromTheReportLibrary: 'Similar cases from the report library',
  hours: '{{v0}} hours',
  timingConfirmedWithYourRequest: 'Timing confirmed with your request',
  includedInYourSubscription: 'Included in your subscription',
  amountDue: 'Amount due: {{v0}}',
  priceOnRequest: 'Price on request',
  selectAReportType: 'Select a report type',
  completeTheRequiredFields: 'Complete the required fields',
  checkTheFormFields: 'Check the form fields',
  requestCreated: 'Request created',
  scorNewAnalyticalReport: 'SCOR · New analytical report',
  reviewBeforeInvesting: 'Review before investing',
  shareTheDocumentsWeWillTurnThem: 'Share the documents. We will turn them into an assessment.',
  anAnalystWillReviewTheOfferS: 'An analyst will review the offer’s economics, fees, liquidity and legal restrictions and assign an independent SCOR.',
  confidential: 'Confidential',
  reportInTheApp: 'Report in the app',
  investmentDocumentReview: 'Investment document review',
  reviewTerms: 'Review terms',
  offerDetails: 'Offer details',
  yourRequestIsSubmittedOnlyAfterYou: '. Your request is submitted only after you confirm.',
  unableToLoadReviewSettings: 'Unable to load review settings',
  pleaseTryAgainLater: 'Please try again later.',
  retry: 'Retry',
  noCategoriesOrReportTypesAreCurrently: 'No categories or report types are currently available.',
  whatAreWeReviewing: 'What are we reviewing? *',
  reportCategory: 'Report category',
  reportType: 'Report type *',
  reportType121: 'Report type',
  hrs: '{{v0}} hrs',
  standardTurnaround: 'Standard turnaround',
  onRequest124: 'on request',
  productNameOrIssuer: 'Product name or issuer *',
  forExampleAgrotechPreIpo: 'For example, AgroTech Pre-IPO',
  investmentAmountRub: 'Investment amount, RUB',
  optional: 'optional',
  optionsCouldNotBeLoaded: 'Options could not be loaded',
  theServiceDidNotProvideOptionsFor: 'The service did not provide options for the field “',
  dragDocumentsHereForReview: 'Drag documents here for review',
  acceptedFormats: 'Accepted formats:',
  chooseFiles: 'Choose files',
  comment: 'Comment',
  whatConcernsYouOrNeedsParticularAttention: 'What concerns you or needs particular attention?',
  youHaveAlreadyAcceptedTheCurrentDocument: 'You have already accepted the current offer',
  iAcceptTheOfferAndPersonalData: 'I accept the offer and personal data processing terms. Documents are used only to prepare the report.',
  theOfferContainsTheTermsForAdding: 'The offer contains the terms for adding reports to the library',
  submitRequest: 'Submit request',
  preparationTime: 'Preparation time:',
  theAnalystWillContactYouIfMore: '. The analyst will contact you if more information is needed.',
  ongoingRequestsAndPublishedScorReports: 'Ongoing requests and published SCOR reports.',
  newAssessment: 'New assessment',
  requestsInProgress: 'Requests in progress',
  request146: 'Request #{{v0}}',
  completedReports: 'Completed reports',
  noCompletedReportsYet: 'No completed reports yet',
  yes: 'Yes',
  no: 'No',
  independentAssessmentResults: 'Independent assessment results',
  investmentProductReport: 'Investment product report',
  advertisedReturn: 'Advertised return: {{v0}}',
  conclusionsAreBasedOnDocumentsAndIndependent: 'Conclusions are based on documents and independent analysis.',
  share: 'Share',
  keyFindings: 'Key findings',
  detailedFindingsWillAppearAfterTheReport: 'Detailed findings will appear after the report is published',
  outcome: 'Outcome',
  stillBeingMonitored: 'Still being monitored',
  checked: 'Checked:',
  scoresByCriterion: 'Scores by criterion',
  questionsForTheSeller: 'Questions for the seller',
  back: 'Back',
  anonymizedAnalysis: 'Anonymized analysis',
  investmentProductsWithIndependentScorAssessmentsAnd: 'Investment products with independent SCOR assessments and recorded outcomes.',
  all: 'All ·',
  withOutcomes: 'With outcomes ·',
  youHaveAccessToPartOfThe: 'You have access to part of the report library.',
  inTheLibrary: 'In the library',
  outcomeRecorded: 'Outcome recorded',
  inThisSelection: 'In this selection',
  medianScore: 'Median score',
  reportCategories: 'Report categories',
  all174: 'All',
  category: 'Category',
  noPublishedReportsInThisSelectionYet: 'No published reports in this selection yet',
  investmentProduct: 'Investment product',
  beingMonitored: 'Being monitored',
  actualOutcome: 'Actual outcome: {{v0}}',
  anAnonymizedAnalysisOfTheProductS: 'An anonymized analysis of the product’s terms, restrictions and key factors.',
  channel: 'Channel',
  checked182: 'Checked',
  actualOutcomeRecorded: 'actual outcome recorded',
  monitoringContinues: 'monitoring continues',
  openReport185: 'Open report',
  availableToMe: 'Available to me',
  reportsSharedWithYouByOtherUsers: 'Reports shared with you by other users.',
  sharedScorReport: 'Shared SCOR report',
  protectedAccessByInvitation: 'Protected access by invitation',
  publicReportCode: 'Public SCOR code',
  findAReportByCode: 'Find a report by code',
  checkAReportSAvailabilityAndYour: 'Check a report’s availability and your access using its public SCOR code.',
  forExampleSc7k3m9a: 'For example, SC-7K3M9A',
  find: 'Find',
  scorReportSearch: 'SCOR report search',
  invitations: 'Invitations',
  ofInvitationsUsed: '{{v0}} of {{v1}} invitations used.',
  newInvitation: 'New invitation',
  report: 'Report #{{v0}}',
  accessViaLink: 'Access via link',
  views: 'Views',
  until: 'Until',
  active: 'Active',
  closed: 'Closed',
  revoke: 'Revoke',
  invitationRegister: 'Invitation register',
  invalidRecipientPhone: 'Enter a valid phone number with country code',
  enterTheRecipientSPhoneNumber: 'Enter the recipient’s phone number',
  linkCopied: 'Link copied',
  shareAccessToAReport: 'Share access to a report',
  createAProtectedLinkOrTieAn: 'Create a protected link or tie an invitation to a phone number.',
  report210: 'Report *',
  selectAReport: 'Select a report',
  manageInvitations: 'Manage invitations',
  accessMode: 'Access mode',
  byLink: 'By link',
  byPhone: 'By phone',
  recipientSPhoneNumber: 'Recipient’s phone number',
  message: 'Message',
  createInvitation: 'Create invitation',
  copy: 'Copy',
  codeApplied: 'Code applied',
  invitationCodeCopied: 'Invitation code copied',
  referralProgram: 'Referral program',
  theProgramIsCurrentlyUnavailable: 'The program is currently unavailable.',
  newInvitationsAreTemporarilyUnavailable: 'New invitations are temporarily unavailable.',
  referralProgramYourNetwork: 'Referral program · Your network',
  yourSharesproNetwork: 'Your SharesPro network',
  anInvitationGivesPersonalAccessNotA: 'An invitation gives personal access, not a promo discount.',
  shareSharesproWithSomeoneYouKnowThe: 'Share SharesPro with someone you know. The code records who invited them, and your account shows the relevant statuses.',
  loading: 'Loading',
  shareInvitation: 'Share invitation',
  yourNetwork: 'Your network',
  confirmed: 'confirmed',
  accessLevel: 'Access level',
  personal: 'Personal',
  withAnIndividualCode: 'With an individual code',
  yourNetworkSharespro: 'Your network · SharesPro',
  becameClients: 'Became clients',
  programStatus: 'Program status',
  active239: 'Active',
  unavailable: 'Unavailable',
  programOverview: 'Program overview',
  availableStatisticsForYourNetwork: 'Available statistics for your network',
  codeShared: 'Code shared',
  totalRecordedInvitations: 'Total recorded invitations',
  confirmedProgramParticipants: 'Confirmed program participants',
  programTerms: 'Program terms',
  yourPersonalManagerCanConfirmTheCurrent: 'Your personal manager can confirm the current terms',
  howAccessWorks: 'How access works',
  aCodeCanOnlyBeAppliedOnce: 'A code can only be applied once.',
  programTermsMayChangeYourPersonalManager: 'Program terms may change. Your personal manager can confirm them.',
  shareTheCode: 'Share the code',
  inAnyConvenientWay: 'In any convenient way.',
  yourFriendEntersIt: 'Your friend enters it',
  duringRegistrationOrInTheirProfile: 'During registration or in their profile.',
  invitationCode: 'Invitation code',
  enterYourInvitationCode: 'Enter your invitation code',
  apply: 'Apply',
  aReferralCodeIsAlreadyLinkedTo: 'A referral code is already linked to your account',
  scorInvoice: 'SCOR invoice',
  invoice: 'Invoice #{{v0}}',
  validUntil: 'Valid until {{v0}}',
  noPaymentDeadlineSpecified: 'No payment deadline specified',
  onlinePayment: 'Online payment',
  bankTransfer: 'Bank transfer',
  overdue: 'Overdue',
  awaitingPayment: 'Awaiting payment',
  openInvoice: 'Open invoice',
  payUsingYourBankSApp: 'Pay using your bank’s app',
  scanTheQrCode: 'Scan the QR code',
  yourBankWillFillInTheAmount: 'Your bank will fill in the amount, recipient and payment reference automatically.',
  unableToGenerateAQrCodeUse: 'Unable to generate a QR code. Use the bank details below.',
  invoicePaymentQrCode: 'Invoice payment QR code',
  saveQrCode: 'Save QR code',
  recipient: 'Recipient',
  taxIdInn: 'Tax ID (INN)',
  taxRegistrationCodeKpp: 'Tax registration code (KPP)',
  accountNumber: 'Account number',
  bank: 'Bank',
  bankIdentificationCodeBik: 'Bank identification code (BIK)',
  correspondentAccount: 'Correspondent account',
  copied: 'Copied: {{v0}}',
  unableToCopyTheValue: 'Unable to copy the value',
  enterYourFirstAndLastNameAt: 'Enter your first and last name — at least two words.',
  enterAValidEmailAddressForThe: 'Enter a valid email address for the receipt.',
  payerDetailsSaved: 'Payer details saved',
  thePaymentLinkWillAppearAfterThe: 'The payment link will appear after the invoice is refreshed.',
  youCanNowPayUsingTheQr: 'You can now pay using the QR code or bank details.',
  refreshTheInvoiceToCheckThePayment: 'Refresh the invoice to check the payment method.',
  invoiceNotFound: 'Invoice not found',
  theInvoiceWasNotFoundOrIs: 'The invoice was not found or is unavailable.',
  checkTheLinkOrReturnToYour: 'Check the link or return to your invoices.',
  subscriptionAndInvoices: 'Subscription and invoices',
  loadingCurrentPaymentDetails: 'Loading current payment details.',
  unableToLoadPaymentDetails: 'Unable to load payment details.',
  scorPayment: 'SCOR payment',
  checkTheAmountAndChooseAnAvailable: 'Check the amount and choose an available payment method.',
  backToInvoices: 'Back to invoices',
  unableToRefreshTheStatusTheLast: 'Unable to refresh the status. The last received details are still shown.',
  amountDue299: 'Amount due',
  invoiceStatus: 'Invoice status',
  invoiceType: 'Invoice type',
  issued: 'Issued',
  payBy: 'Pay by',
  order: 'Order',
  notLinked: 'Not linked',
  paymentDeadlinePassed: 'Payment deadline passed',
  youCanStillPayThisInvoiceIts: 'The invoice remains open and can still be paid.',
  paymentReceived: 'Payment received',
  theInvoiceStatusHasBeenUpdatedNo: 'The invoice status has been updated. No further action is needed.',
  invoiceClosed: 'Invoice closed',
  thisInvoiceCanNoLongerBePaid: 'This invoice can no longer be paid.',
  receiptDetails: 'Receipt details',
  enterPayerDetails: 'Enter payer details',
  thePayerSNameWillAppearIn: 'The payer’s name will appear in the payment reference, and the receipt will be sent by email.',
  firstAndLastName: 'First and last name *',
  receiptEmail: 'Receipt email *',
  saveAndProceedToPayment: 'Save and proceed to payment',
  saveAndShowBankDetails: 'Save and show bank details',
  saveDetails: 'Save details',
  thePaymentMethodIsNotYetAvailable: 'The payment method is not yet available.',
  refreshInvoice: 'Refresh invoice',
  payOnTheSecurePage: 'Pay on the secure page',
  theLinkWillOpenOnThisDevice: 'The link will open on this device and may launch your bank’s app.',
  proceedToPayment: 'Proceed to payment',
  theLinkIsNotYetAvailable: 'The link is not yet available.',
  paymentDetails: 'Payment details',
  copy327: 'Copy: {{v0}}',
  bankDetailsHaveNotBeenPublishedYet: 'Bank details have not been published yet. Refresh the invoice later.',
  paymentReference: 'Payment reference',
  reference: 'Reference',
  enterYourPhoneNumber: 'Enter your phone number',
  acceptanceOfTheOfferIsRequired: 'Acceptance of the offer is required',
  selectAnAvailablePlanAndBillingPeriod: 'Select an available plan and billing period',
  aManagerWillContactYouShortly: 'A manager will contact you shortly.',
  fullAccessToReportsRecordedOutcomesAnd: 'Full access to reports, recorded outcomes and protected report sharing.',
  subscriptionActive: 'Subscription active',
  discountOnAdditionalReports: 'Discount on additional reports',
  upTo: 'Up to',
  protectedInvitations: 'protected invitations',
  yourAccess: 'Your access',
  paidUntil: 'Paid until',
  reportsUsed: 'Reports used:',
  reportsRemaining: 'Reports remaining:',
  period: 'Period:',
  requestAmount: 'Request amount:',
  unableToLoadYourRequestStatus: 'Unable to load your request status.',
  checkYourContactPhoneNumberNameAnd: 'Check your contact phone number. Name and email are optional.',
  plan: 'Plan',
  selectAPlan: 'Select a plan',
  billingPeriod: 'Billing period',
  selectAPeriod: 'Select a period',
  perPeriod: 'per period',
  selectAnAvailablePlanAndBillingPeriod353: 'Select an available plan and billing period.',
  reloadPlans: 'Reload plans',
  select: 'Select',
  yourName: 'Your name',
  phone: 'Phone *',
  iAcceptTheOffer: 'I accept the offer',
  requestSubscription: 'Request subscription',
  plans: 'Plans',
  payment: 'Payment',
  invoicesAwaitingPayment: 'Invoices awaiting payment',
  support: 'Support',
  aboutScorMethodologySubscriptionsAndPrivacy: 'About SCOR methodology, subscriptions and privacy.',
  stillHaveAQuestion: 'Still have a question?',
  messageTheSharesproSupportChat: 'Message the SharesPro support chat.',
  openChat: 'Open chat',
  scorRulesAndSecurity: 'SCOR · Rules and security',
  legalDocuments: 'Legal documents',
  scorDocuments: 'SCOR documents',
  serviceTermsConsentsAndCurrentDocumentVersions: 'Service terms, consents and current document versions in one protected section.',
  currentVersions: 'Current versions',
  consentTracking: 'Consent tracking',
  protectedAccess: 'Protected access',
  protectedScorDocumentStorage: 'Protected SCOR document storage',
  documents376: 'Documents',
  consentRequired: 'Consent required',
  status: 'Status',
  upToDate: 'Up to date',
  actionNeeded: 'Action needed',
  documentsHaveNotBeenPublishedYet: 'Documents have not been published yet.',
  version: 'Version',
  effectiveFrom: '· effective from',
  consentRequired384: 'Consent required',
  open385: 'Open →',
  selectACategory: 'Select a category',
  enterAProductNameOrIssuer: 'Enter a product name or issuer',
  noMoreThan255Characters: 'No more than 255 characters',
  noMoreThan2000Characters: 'No more than 2,000 characters',
  youMustAcceptTheDocuments: 'You must accept the documents',
  addAtLeastOneDocument: 'Add at least one document',
  enterAnAmountOf0OrMore: 'Enter an amount of 0 or more',
  confirmationRequired: 'Confirmation required',
  completeThisRequiredField: 'Complete this required field',
  selectAnAvailableOption: 'Select an available option',
  enterANumber: 'Enter a number',
  businessDays: '{{v0}} business days',
  businessDay: '{{v0}} business day',
  businessDays399: '{{v0}} business days',
  unableToLoadUploadSettingsPleaseReload: 'Unable to load upload settings. Please reload.',
  youCanAttachUpToFiles: 'You can attach up to {{v0}} files',
  theFileExceeds: '{{v0}}: the file exceeds {{v1}}',
  mb: '{{v0}} MB',
  bytes: '{{v0}} bytes',
  unsupportedFileFormat: '{{v0}}: unsupported file format',
};
